import { render, staticRenderFns } from "./CookieConsentBanner.vue?vue&type=template&id=5c0401f6&scoped=true"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=ts"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=ts"
import style0 from "./CookieConsentBanner.vue?vue&type=style&index=0&id=5c0401f6&prod&lang=scss&scoped=true"
import style1 from "./CookieConsentBanner.vue?vue&type=style&index=1&id=5c0401f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0401f6",
  null
  
)

export default component.exports